module.exports = __webpack_public_path__ + "static/media/landing-gradient.de66c8ef.png";